/**
 * no operate function
 */
export function noop() {
  return;
}
